import Sidebar from './Sidebar'
import { Outlet } from 'react-router-dom'
import useAuth from './../hooks/useAuth';
import AdminSidebar from './AdminSidebar';
import BuyerSidebar from './BuyerSidebar';

const Layout = ({ children }) => {

  const { auth } = useAuth()


  const sidebar = () => {

    let userIsBuyer = false, userIsPUBLISHER = false, userIsPRODUCER = false

    if (auth?.role?.includes('BUYER')) userIsBuyer = true
    if (auth?.role?.includes('PUBLISHER')) userIsPUBLISHER = true
    if (auth?.role?.includes('PRODUCER')) userIsPRODUCER = true

    if (auth?.role?.length === 1 && auth?.role[0] == 'BUYER') return <BuyerSidebar />

    if (auth?.role?.[0] == 'ADMIN') {
      return <AdminSidebar buyer={userIsBuyer} />
    } else {
      return <Sidebar buyer={userIsBuyer} publisher={userIsPUBLISHER} producer={userIsPRODUCER} />
    }
  }

  return (
    <>
      {sidebar()}

      <div className='content'>
        <Outlet />
      </div>
    </>
  )
}

export default Layout
